<script>
import TablePage from '@/found/components/table_page';
import { Form } from '@/found/views/mdm/views/terminal_info/form';

export default {
  extends: TablePage,
  data() {
    return {
      formConfig: {},
    };
  },
  components: {
    Form,
  },
  props: {
    propsObj: Object,
  },
  mounted() {
    this.params = { regionCode: this.propsObj.row.regionCode, regionLevel: this.propsObj.row.regionLevel };
    this.getConfigList('terminal_list');
  },
  methods: {
    cellClick({ row, column }) {
      if (column.property === 'terminalCode') {
        this.formName = 'Form';
        this.formConfig = {
          ...row,
        //   type: 'fengxianghui',
        };
        this.formConfig.code = 'view';
        this.modalConfig.title = '终端信息';
        this.openFull();
      }
    },
  },
};
</script>
